<div id="product-spec-dialog-close" [mat-dialog-close]="true">
  <mat-icon>close</mat-icon>
</div>
<div id="product-spec-dialog" class="dialog">
  <div [class]="data?.specs ? 'fx-row fx-row-h-space-between' : 'fx-row fx-row-h-right'">

    @if (data?.specs) {
      <div id="product-spec-dialog-content" class="fx-row fx-row-v-center">
        <h3 id="product-spec-dialog-title">Specifications Comparison</h3>
      </div>
    }
  </div>

  <div
    class="fx-row fx-row-v-center options-tab mx-auto"
    [class.invisible]="data?.options && data.options.length <= 1"
    >
    @for (data of data?.options; track data; let k = $index) {
      <button
        class="option-tab mb-3"
        (click)="this.selectedTable = k"
        [class.active]="selectedTable == k"
        >
        <span>{{ data?.tab_name }}</span>
      </button>
    }
  </div>

  <div class="product-spec-dialog-table fx-row">
    @if (data?.specs) {
      <div class="fx-col">
        @for (spec of get(data, 'specs', []); track spec) {
          <div>
            <div class="cell-left fx-row fx-row-v-center">
              <p class="ml-2 mr-2">{{ spec }}</p>
            </div>
          </div>
        }
      </div>
    }

    @if (data?.specs) {
      <div class="fx-row">
        @for (values of get(data, 'values', []); track values; let i = $index) {
          <div>
            @for (value of values; track value; let j = $index) {
              <div class="cell-right fx-row fx-row-v-center">
                @if (j != 1) {
                  <p class="ml-2 mr-2 truncate-ellipsis">{{ value }}</p>
                }
                @if (j == 1) {
                  <a class="link-blue ml-2 mr-2 truncate-ellipsis" [href]="(data?.links)[i]" target="_blank">{{
                    value
                  }}</a>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    @if (data?.options) {
      <div class="options-table">
        <div [innerHTML]="(data?.options)[selectedTable]?.table_content | safe: 'html'"></div>
      </div>
    }
  </div>
</div>
